import { View, ScrollView } from "react-native";
import React, { memo, useEffect, useRef, useState, useCallback } from "react";
import { AppColors } from "../../../utility/AppColors";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppScreens } from "../../Utility/AppScreens";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";

import { getEventId } from "../../../utility/AppStoreData";
import { genres } from "../../../Api/configs";
import EventTypeScreen from "../Event/EventTypeScreen";
import SearchFromFriendsModal from "../Event/SearchFromFriendsModal";
import NotificationDetails from "./Notifications/NotificationPopup/NotificationDetails";
import HomeHeader from "../../../Components/home-common-components/HomeHeader";
import Separator from "../../../Components/Separator";
import CreateEventModal from "../Event/CreateEventModal";
import {
  fetchPastEventsEnhanced,
  fetchPopularEventsEnhanced,
  fetchRecommendedEventsEnhanced,
  fetchUpcomingEventsEnhanced,
  fetchGenreGamesEnhanced,
  fetchLiveNowGamesEnhanced,
} from "../../../services/eventsAPIEnhanced";
import { handleApiError } from "../../../services/errorHandler";
import ChallengeConfirmationModal from "./Notifications/NotificationPopup/ChallengeConfirmationModal";
import { toast } from "react-toastify";
import { useUserData } from "../../../context/UserDataContext";
import { useAuthProvider } from "../../../context/AuthContext";
import { clearOnlyApiCaches } from "../../../utility/cacheManager";
import {
  getStoredEventShareURL,
  clearStoredEventShareURL,
  getStoredEventShareAction,
  getPendingChallengeAccept,
  clearPendingChallengeAccept,
} from "../../../utility/urlUtils";
// Import debug utilities (only in development)
if (process.env.NODE_ENV === "development") {
  import("../../../utility/clearCacheDebug");
}

import { useTooltips } from "../../../context/WalkthroughContext";
import { ScreenBGGradientView } from "../../../common/CommonView";
import { ShowLoader } from "../../../common/ShowLoader";
import Header from "./Common/Header";
import HomeWebScreenSkeleton from "../../../Components/skeleton-components/HomeWebScreenSkeleton";
import LiveNowSlider from "../../../Components/home-common-components/LiveNowSlider";
import BrowsGamesComponent from "../../../Components/home-common-components/BrowsGamesComponent";
import Cards from "../../../Components/Cards";
import ReferAndEarn from "../../../Components/ReferAndEarn";
import AllSetPopup from "../../../Components/AllSetPopup";
// import GreatEffortModal from "../../../Components/home-common-components/YouGaveItAll-popup";                              //you got it all popup
import WelcomeTooltip from "../../../Components/walk-through-common-components/homeScreenTooltips/WelcomeTooltip";
import SidebarTopWalkthrough from "../../../Components/walk-through-common-components/homeScreenTooltips/SidebarTopWalkthrough";
import GetTicketWalkthrough from "../../../Components/walk-through-common-components/homeScreenTooltips/GetTicketWalkthrough";
import SignUpWalkthrough from "../../../Components/walk-through-common-components/homeScreenTooltips/SignUpWalkthrough";
import WelcomePopup from "./PostSignupPopups/WelcomePopup";
import ChallengeActionPopup from "./PostSignupPopups/ChallengeActionPopup";
import { LiveSoloStreamersContainer } from "../../../Components/solo-streaming-components";
// import CashOutDetailsModal from "../../../Components/profile-common-components/CashOutDetailsPopup"; // cash out details popup
// import EventCompletedModal from "../../../Components/home-common-components/EventCompletedPopup";                          // event complete popup
// import DisputeOccurredModal from "../../../Components/home-common-components/DisputeOccuredPopup";                        //dispute occured popup
// import ResultSubmissionModal from "../../../Components/home-common-components/Result-submission-popup";                   //result submission popup
// import CoinsPopup from "../../../Components/home-common-components/WhatAreCoinsPopup";                                    // what are coins popup

interface HomeWebScreenProps {
  route: any;
}

const HomeWebScreen: React.FC<HomeWebScreenProps> = memo(({ route }) => {
  const { eventID, showWelcome } = route.params || {};
  const navigation = useNavigation();
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const { userData, userProfileData, accessToken, isLoading, fetchUserData } =
    useUserData();
  const { isLoggedIn, hasJustLoggedIn } = useAuthProvider();

  const [searchFromFriendsModal, setSearchFromFriendsModal] = useState(false);
  const [arrPopularGeners, arrSetPopularGeners] = useState(genres);
  const [originalPopularData, setOriginalPopularData] = useState([]);
  const [popularData, setPopulerData] = useState([]);
  const [popularEmpty, setPopulerEmpty] = useState(false);
  const [originalUpcomingData, setOriginalUpcomingData] = useState([]);
  const [upComingData, setUpComingData] = useState([]);
  const [pastEventData, setPastEventData] = useState([]);
  const [upComingEmpty, setUpComingEmpty] = useState(false);
  const [originalRecommendedData, setOriginalRecommendedData] = useState([]);
  const [recommendedData, setRecommendedData] = useState([]);
  const [recommendedEmpty, setRecommendedEmpty] = useState(false);
  const [pastEventEmpty, setPastEventEmptyEmpty] = useState(false);

  const [showEventTypeModal, setShowEventTypeModal] = useState(false);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [currentSignupFlowContext, setCurrentSignupFlowContext] =
    useState(null);

  const [challengeID, setChallengeID] = useState("");
  const [showNotificationDetails, setShowNotificationDetails] = useState(false);

  const [showChallengeConformation, setChallengeConformation] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [challengeActionPopup, setChallengeActionPopup] = useState(false);
  const [challengeActionType, setChallengeActionType] = useState("reject");
  const [challengeAutoRedirect, setChallengeAutoRedirect] = useState(false);
  const [isMyEvents, setIsMyEvents] = useState(false);
  // const [isGetTicket, setIsGetTicket] = useState(false);
  // const [isCashOutModalVisible, setIsCashOutModalVisible] = useState(true); // cash out details popup

  const [popularIndex, setPopularIndex] = useState(0);

  const [upcomingIndex, setUpcomingIndex] = useState(0);

  const [recommendedIndex, setRecommendedIndex] = useState(0);
  const [pastEventIndex, setPastEventIndex] = useState(0);

  const [showEventPopulerLoader, setShowEventPopulerLoader] = useState(false);
  const [showRecommendedEventLoader, setShowRecommendedEventLoader] =
    useState(false);
  const [showUpComingEventLoader, setShowUpComingEventLoader] = useState(false);
  const [showPastEventLoader, setShowPastEventLoader] = useState(false);
  const {
    tooltipVisible,
    setTooltipVisible,
    setTotalSteps,
    setCurrentStep,
    setHomeWalkThroughVisible,
  } = useTooltips();

  const [gameResult, setGameResult] = useState([]);
  const [gameResultEmpty, setGameResultEmpty] = useState(false);
  const [showGameResultLoader, setShowGameResultLoader] = useState(false);
  const [liveEventsData, setLiveEventsData] = useState([]);
  const [showLiveEventsLoader, setShowLiveEventsLoader] = useState(false);
  const [ReferAndEarnPopup, setReferAndEarnPopup] = useState(false);
  const [AllSetupPopup, setAllSetupPopup] = useState(false);
  // const [modalVisible, setModalVisible] = useState(true); //result submission popup
  // const [isModalVisible, setModalVisible] = useState(true); //event complete popup

  // const handleResultSubmit = (result: "win" | "loss") => {
  //   setModalVisible(false); // Close the event complete popup modal after submission
  // };

  // const [modalVisible, setModalVisible] = useState(true);        help decide winner popup

  const [obsErrorPopup, setObsErrorPopup] = useState(true);
  const [popularLastEvaluatedKey, setPopularLastEvaluatedKey] = useState(null);
  const [recommendedLastEvaluatedKey, setRecommendedLastEvaluatedKey] =
    useState(null);
  const [upcomingLastEvaluatedKey, setUpcomingLastEvaluatedKey] =
    useState(null);
  const [pastLastEvaluatedKey, setPastLastEvaluatedKey] = useState(null);
  const [isFetchingMorePopularEvents, setIsFetchingMorePopularEvents] =
    useState(false);
  const [isFetchingMoreRecommendedEvents, setIsFetchingMoreRecommendedEvents] =
    useState(false);
  const [isFetchingMoreUpcomingEvents, setIsFetchingMoreUpcomingEvents] =
    useState(false);
  const [isFetchingMorePastEvents, setIsFetchingMorePastEvents] =
    useState(false);
  const [recommendedLimit, setrecommendedLimit] = useState(8);
  const [popularLimit, setPopularLimit] = useState(8);
  const [upcomingLimit, setUpcomingLimit] = useState(8);
  const [pastLimit, setPastLimit] = useState(8);
  const initialRecommendedLoadRef = useRef(true);
  const initialUpcomingLoadRef = useRef(true);
  const initialPastLoadRef = useRef(true);
  const initialPopularLoadRef = useRef(true);
  const initializingRef = useRef(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [isInitializing, setIsInitializing] = useState(false);

  const closePopup = () => {
    setAllSetupPopup(false);
  };

  // Debug function to log current flow status
  const logCurrentFlowStatus = () => {
    console.log("🔍 HomeWebScreen Flow Status Debug:");
    console.log("  - showWelcomeModal:", showWelcomeModal);
    console.log("  - currentSignupFlowContext:", currentSignupFlowContext);
    console.log(
      "  - sessionStorage signupFlowContext:",
      sessionStorage.getItem("signupFlowContext")
    );
    console.log(
      "  - sessionStorage showWelcomeAfterSignup:",
      sessionStorage.getItem("showWelcomeAfterSignup")
    );
    console.log(
      "  - sessionStorage postConfirmationRedirect:",
      sessionStorage.getItem("postConfirmationRedirect")
    );
    console.log("  - isLoggedIn:", isLoggedIn);
    console.log("  - userData?.username:", userData?.username);
  };

  // Log flow status when key states change (only in development)
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      logCurrentFlowStatus();
    }
  }, [
    showWelcomeModal,
    currentSignupFlowContext,
    isLoggedIn,
    userData?.username,
  ]);

  // Function declarations moved before usage
  const getGenreGames = useCallback(async () => {
    try {
      setShowGameResultLoader(true);
      const response = await fetchGenreGamesEnhanced(); // Use enhanced version with caching
      const responseBody =
        typeof response.body === "string"
          ? JSON.parse(response.body) // Parse the stringified JSON
          : response.body;

      if (response.statusCode === 200) {
        if (responseBody === 0) {
          setGameResultEmpty(true);
          setShowGameResultLoader(false);
        }

        setGameResult(responseBody); // Update the state with the list of titles
        setShowGameResultLoader(false); // Hide the loader
      } else {
        toast.error(responseBody.error); // Show error message
      }
    } catch (error) {
      console.error("get games API Error:- ", error.message);
      toast.error(error.message); // Show toast notification for errors
    }
  }, []);

  const getLiveEvents = useCallback(async () => {
    try {
      setShowLiveEventsLoader(true);
      const response = await fetchLiveNowGamesEnhanced();

      if (response.statusCode === 200 && response.events) {
        setLiveEventsData(response.events);
      } else {
        setLiveEventsData([]);
      }
    } catch (error) {
      console.error("get live events API Error:- ", error.message);
      setLiveEventsData([]);
    } finally {
      setShowLiveEventsLoader(false);
    }
  }, []);

  const getEventPopuler = useCallback(
    async (username: string, limit: number, paginationKey = undefined) => {
      if (initialPopularLoadRef.current) {
        setShowEventPopulerLoader(true);
      }
      if (paginationKey) setIsFetchingMorePopularEvents(true);

      try {
        const response = await fetchPopularEventsEnhanced(
          username,
          limit,
          paginationKey
        );

        if (response?.statusCode === 200 && Array.isArray(response.events)) {
          const events = response.events;
          const lastKey = response.lastEvaluatedKey || undefined;
          if (initialPopularLoadRef.current) {
            console.log(
              "Popular Events - Initial Load:",
              events.length,
              "events"
            );
            setOriginalPopularData(events);
            setPopulerData(events);
            setPopularLimit(5);
            initialPopularLoadRef.current = false;
            // Set empty state for popular events
            setPopulerEmpty(events.length === 0);
          } else {
            console.log(
              "Popular Events - Pagination Load:",
              events.length,
              "new events"
            );
            // Filter out duplicates when appending
            setOriginalPopularData((prev) => {
              const existingIds = new Set(
                prev.map((event) => event.eventId || event.id)
              );
              const newEvents = events.filter(
                (event) => !existingIds.has(event.eventId || event.id)
              );
              console.log(
                "Popular Events - Filtered duplicates:",
                events.length - newEvents.length,
                "duplicates removed"
              );
              return [...prev, ...newEvents];
            });
            setPopulerData((prev) => {
              const existingIds = new Set(
                prev.map((event) => event.eventId || event.id)
              );
              const newEvents = events.filter(
                (event) => !existingIds.has(event.eventId || event.id)
              );
              return [...prev, ...newEvents];
            });
          }

          setPopularLastEvaluatedKey((prevLastKey: any) => {
            if (prevLastKey && prevLastKey === lastKey) {
              return null;
            }
            return lastKey;
          });
        } else {
          handleApiError(
            response.statusCode || 500,
            "Events data missing or malformed"
          );
        }
      } catch (error: any) {
        toast.error(error.message);
      } finally {
        if (paginationKey) setIsFetchingMorePopularEvents(false);
        setShowEventPopulerLoader(false);
      }
    },
    []
  );

  const getRecommendedEvent = useCallback(
    async (username: string, limit: number, paginationKey = undefined) => {
      if (initialRecommendedLoadRef.current)
        setShowRecommendedEventLoader(true);
      if (paginationKey) setIsFetchingMorePopularEvents(true);

      try {
        const response = await fetchRecommendedEventsEnhanced(
          username,
          limit,
          paginationKey
        );

        const responseBody =
          typeof response.body === "string"
            ? JSON.parse(response.body)
            : response.body;

        if (response.statusCode === 200 && Array.isArray(responseBody.events)) {
          const lastKey = responseBody.lastEvaluatedKey || undefined;
          const events = responseBody.events;
          events.length === 0
            ? setRecommendedEmpty(true)
            : setRecommendedEmpty(false);
          if (initialRecommendedLoadRef.current) {
            setOriginalRecommendedData(events);
            setRecommendedData(events);
            setrecommendedLimit(5);
            initialRecommendedLoadRef.current = false;
          } else {
            console.log(
              "Recommended Events - Pagination Load:",
              events.length,
              "new events"
            );
            // Filter out duplicates when appending
            setOriginalRecommendedData((prev) => {
              const existingIds = new Set(
                prev.map((event) => event.eventId || event.id)
              );
              const newEvents = events.filter(
                (event) => !existingIds.has(event.eventId || event.id)
              );
              console.log(
                "Recommended Events - Filtered duplicates:",
                events.length - newEvents.length,
                "duplicates removed"
              );
              return [...prev, ...newEvents];
            });
            setRecommendedData((prev) => {
              const existingIds = new Set(
                prev.map((event) => event.eventId || event.id)
              );
              const newEvents = events.filter(
                (event) => !existingIds.has(event.eventId || event.id)
              );
              return [...prev, ...newEvents];
            });
          }
          setRecommendedLastEvaluatedKey((prevLastKey: any) => {
            if (prevLastKey && prevLastKey === lastKey) {
              return null;
            }
            return lastKey;
          });
        } else {
          handleApiError(response.statusCode, responseBody.error);
        }
      } catch (error) {
      } finally {
        if (paginationKey) setIsFetchingMoreRecommendedEvents(false);
        setShowRecommendedEventLoader(false);
      }
    },
    []
  );

  const getUpComingEvent = useCallback(
    async (username: string, limit: number, paginationKey = undefined) => {
      if (initialUpcomingLoadRef.current) setShowUpComingEventLoader(true);
      if (paginationKey) setIsFetchingMoreUpcomingEvents(true);
      try {
        const response = await fetchUpcomingEventsEnhanced(
          username,
          limit,
          paginationKey
        );

        const responseBody =
          typeof response === "string" ? JSON.parse(response) : response;

        if (
          responseBody.statusCode === 200 &&
          Array.isArray(responseBody.events)
        ) {
          const lastKey = responseBody.lastEvaluatedKey || undefined;
          const events = responseBody.events;

          events.length === 0
            ? setUpComingEmpty(true)
            : setUpComingEmpty(false);
          if (initialUpcomingLoadRef.current) {
            setOriginalUpcomingData(events);
            setUpComingData(events);
            setUpcomingLimit(5);
            initialUpcomingLoadRef.current = false;
          } else {
            console.log(
              "Upcoming Events - Pagination Load:",
              events.length,
              "new events"
            );
            // Filter out duplicates when appending
            setOriginalUpcomingData((prev) => {
              const existingIds = new Set(
                prev.map((event) => event.eventId || event.id)
              );
              const newEvents = events.filter(
                (event) => !existingIds.has(event.eventId || event.id)
              );
              console.log(
                "Upcoming Events - Filtered duplicates:",
                events.length - newEvents.length,
                "duplicates removed"
              );
              return [...prev, ...newEvents];
            });
            setUpComingData((prev) => {
              const existingIds = new Set(
                prev.map((event) => event.eventId || event.id)
              );
              const newEvents = events.filter(
                (event) => !existingIds.has(event.eventId || event.id)
              );
              return [...prev, ...newEvents];
            });
          }
          setUpcomingLastEvaluatedKey((prevLastKey: any) => {
            if (prevLastKey && prevLastKey === lastKey) {
              return null;
            }
            return lastKey;
          });
        } else {
          handleApiError(response.statusCode, responseBody.error);
        }
      } catch (error: any) {
        console.log("Authorization failed: " + error.message);
        toast.error(error.message);
      } finally {
        if (paginationKey) setIsFetchingMoreUpcomingEvents(false);
        setShowUpComingEventLoader(false);
      }
    },
    []
  );

  const getPastEvent = useCallback(
    async (accessToken: string, limit: number, paginationKey = undefined) => {
      if (initialPastLoadRef.current) setShowPastEventLoader(true);
      if (paginationKey) setIsFetchingMorePastEvents(true);

      try {
        const response = await fetchPastEventsEnhanced(
          accessToken,
          limit,
          paginationKey
        );
        const responseBody =
          typeof response.body === "string"
            ? JSON.parse(response.body)
            : response.body;
        if (response.statusCode === 200 && Array.isArray(responseBody.events)) {
          const lastKey = responseBody.lastEvaluatedKey || undefined;
          const events = responseBody.events;

          events.length === 0
            ? setPastEventEmptyEmpty(true)
            : setPastEventEmptyEmpty(false);
          if (initialPastLoadRef.current) {
            setPastEventData(events);
            setPastLimit(5);
            initialPastLoadRef.current = false;
          } else {
            console.log(
              "Past Events - Pagination Load:",
              events.length,
              "new events"
            );
            // Filter out duplicates when appending
            setPastEventData((prev) => {
              const existingIds = new Set(
                prev.map((event) => event.eventId || event.id)
              );
              const newEvents = events.filter(
                (event) => !existingIds.has(event.eventId || event.id)
              );
              console.log(
                "Past Events - Filtered duplicates:",
                events.length - newEvents.length,
                "duplicates removed"
              );
              return [...prev, ...newEvents];
            });
          }
          setPastLastEvaluatedKey((prevLastKey: any) => {
            if (prevLastKey && prevLastKey === lastKey) {
              return null;
            }
            return lastKey;
          });
        } else {
          handleApiError(response.statusCode, responseBody.error);
        }
      } catch (error) {
      } finally {
        if (paginationKey) setIsFetchingMorePastEvents(false);
        setShowPastEventLoader(false);
      }
    },
    []
  );

  const initializeData = useCallback(
    async (forceRefresh = false) => {
      if (!userData?.username || initializingRef.current) return;

      initializingRef.current = true;
      setIsInitializing(true);

      try {
        // Clear API caches on force refresh (e.g., after login)
        if (forceRefresh) {
          console.log("🔄 Clearing API caches for fresh data after login");
          clearOnlyApiCaches();
        }

        console.log(
          "🚀 Initializing home screen data for user:",
          userData.username
        );

        // Run all API calls in parallel for faster loading
        await Promise.all([
          getGenreGames(),
          getLiveEvents(),
          getEventPopuler(userData.username, 8),
          getUpComingEvent(userData.username, 8),
          getRecommendedEvent(userData.username, 8),
        ]);

        if (accessToken) {
          getPastEvent(accessToken, 8);

          const eventId = await getEventId();
          if (eventId) {
            setChallengeID(eventId);
            setShowNotificationDetails(true);
          }
        }

        // Add small delay before showing content to ensure smooth transition
        await new Promise((resolve) => setTimeout(resolve, 500));

        // Mark initial data as loaded - only set this once
        if (!initialDataLoaded) {
          setInitialDataLoaded(true);
          console.log("✅ Initial home screen data loaded");
        }
      } finally {
        initializingRef.current = false;
        setIsInitializing(false);
      }
    },
    [
      userData?.username,
      accessToken,
      getGenreGames,
      getLiveEvents,
      getEventPopuler,
      getUpComingEvent,
      getRecommendedEvent,
      getPastEvent,
      initialDataLoaded,
    ]
  );

  // Main useEffect for initializing data - only runs once when userData is available
  useEffect(() => {
    if (userData?.username && !initialDataLoaded && !initializingRef.current) {
      console.log("📊 First time loading home screen data");
      initializeData();
    }
  }, [userData?.username, initialDataLoaded, initializeData]);

  // Fallback useEffect in case userData takes time to load
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (isLoggedIn && !userData?.username && !isLoading) {
      console.log(
        "⏱️ Login detected but userData not ready, retrying in 1 second..."
      );
      timeoutId = setTimeout(() => {
        fetchUserData().then(() => {
          console.log("🔄 Retried fetching user data");
        });
      }, 1000);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isLoggedIn, userData?.username, isLoading, fetchUserData]);

  // Handle welcome popup for new users completing signup flow with unified flow detection
  useEffect(() => {
    const shouldShowWelcome =
      showWelcome ||
      sessionStorage.getItem("showWelcomeAfterSignup") === "true";

    if (shouldShowWelcome && userData?.username) {
      console.log(
        "🎉 HomeWebScreen: Processing welcome popup for new user:",
        userData.username
      );

      // Check for unified signup flow context
      const signupFlowContextStr = sessionStorage.getItem("signupFlowContext");
      if (signupFlowContextStr) {
        try {
          const signupFlowContext = JSON.parse(signupFlowContextStr);
          console.log(
            "💾 HomeWebScreen: Found signup flow context:",
            signupFlowContext
          );

          // Store context in component state for other components to use
          setCurrentSignupFlowContext(signupFlowContext);

          // Log flow type for debugging
          console.log(
            `🚀 HomeWebScreen: Handling ${signupFlowContext.flowType} signup flow completion`
          );

          if (signupFlowContext.flowType === "gameshow") {
            console.log(
              "🎮 HomeWebScreen: GameShow flow - will suppress claim coins popup"
            );
          } else if (signupFlowContext.flowType === "notification") {
            console.log(
              "🔔 HomeWebScreen: Notification flow - claim coins popup allowed after welcome"
            );
          }
        } catch (error) {
          console.warn(
            "⚠️ HomeWebScreen: Error parsing signup flow context:",
            error
          );
        }
      } else {
        // Clear context state if no sessionStorage context found
        setCurrentSignupFlowContext(null);
      }

      // Small delay to ensure the home screen is fully loaded
      setTimeout(() => {
        setShowWelcomeModal(true);
        // Clear the signup flag after showing popup to prevent repeat shows
        sessionStorage.removeItem("showWelcomeAfterSignup");
      }, 1000);
    }
  }, [showWelcome, userData?.username]);

  // Check for pending challenge accept after token purchase
  // If found, redirect to /notifications where the proper modal flow can happen
  useEffect(() => {
    if (!isLoggedIn || !userData?.username) return;

    // Check for token purchase return
    const urlParams = new URLSearchParams(window.location.search);
    const tokenPurchased = urlParams.get("token") === "true";

    console.log("🔍 HomeWebScreen: Checking for pending challenge", {
      tokenPurchased,
      url: window.location.href,
      pathname: window.location.pathname,
    });

    const pendingChallenge = getPendingChallengeAccept();
    if (pendingChallenge) {
      console.log(
        "🎯 HomeWebScreen: Found pending challenge, redirecting to notifications:",
        pendingChallenge
      );
      // DON'T clear the context - let Notifications.tsx handle it
      // Redirect to notifications page where proper modal handling exists
      const redirectUrl = tokenPurchased
        ? "/notifications?token=true"
        : "/notifications";
      console.log("🔄 Redirecting to:", redirectUrl);
      navigation.dispatch(
        StackActions.replace("NotificationTabStack", {
          screen: "Notifications",
          params: tokenPurchased ? { token: "true" } : {},
        })
      );
    }
  }, [isLoggedIn, userData?.username, navigation]);

  // Handle post-authentication redirect for event share URLs
  useEffect(() => {
    if (isLoggedIn && userData?.username) {
      // Don't redirect if welcome modal is currently showing or should be shown
      const showWelcomeAfterSignup =
        sessionStorage.getItem("showWelcomeAfterSignup") === "true";
      if (showWelcomeAfterSignup || showWelcomeModal) {
        return; // Let welcome popup show first, then redirect after it closes
      }

      // Check for loginFlowContext (from login flow)
      const loginFlowContextStr = sessionStorage.getItem("loginFlowContext");
      if (loginFlowContextStr) {
        try {
          const loginFlowContext = JSON.parse(loginFlowContextStr);

          if (loginFlowContext.postLoginRedirectURL) {
            console.log(
              "🎮 Login flow detected in Home, redirecting to:",
              loginFlowContext.postLoginRedirectURL
            );

            // Clean up login flow context
            sessionStorage.removeItem("loginFlowContext");

            // Redirect to GameShow
            window.location.href = loginFlowContext.postLoginRedirectURL;
            return;
          }

          // Clean up even if no redirect URL
          sessionStorage.removeItem("loginFlowContext");
        } catch (error) {
          console.error("Error parsing loginFlowContext in Home:", error);
          sessionStorage.removeItem("loginFlowContext");
        }
      }

      // Priority 2: Check for postConfirmationRedirect in signupFlowContext (from signup flow)
      const postConfirmationRedirect = sessionStorage.getItem(
        "postConfirmationRedirect"
      );
      if (postConfirmationRedirect) {
        console.log(
          "🎮 Signup flow complete, redirecting to:",
          postConfirmationRedirect
        );

        // Clean up ALL signup-related storage RIGHT BEFORE redirect
        sessionStorage.removeItem("postConfirmationRedirect");
        sessionStorage.removeItem("signupFlowContext");
        clearStoredEventShareURL();

        // Redirect to the stored event URL (e.g., GameShow)
        window.location.href = postConfirmationRedirect;
        return;
      }

      // Priority 3: Check for postLoginRedirectURL in signupFlowContext (after signup)
      const signupFlowContextStr = sessionStorage.getItem("signupFlowContext");
      if (signupFlowContextStr) {
        try {
          const signupFlowContext = JSON.parse(signupFlowContextStr);
          if (signupFlowContext.postLoginRedirectURL) {
            console.log(
              "🔄 HomeWebScreen: Redirecting to postLoginRedirectURL from signupFlowContext:",
              signupFlowContext.postLoginRedirectURL
            );
            sessionStorage.removeItem("signupFlowContext");
            clearStoredEventShareURL();
            window.location.href = signupFlowContext.postLoginRedirectURL;
            return;
          }
        } catch (error) {
          console.warn(
            "⚠️ HomeWebScreen: Error parsing signupFlowContext for redirect:",
            error
          );
        }
      }

      // Priority 4: Check for stored event URL (legacy direct login flow)
      const storedEventUrl = getStoredEventShareURL();
      if (storedEventUrl) {
        console.log(
          "🔄 HomeWebScreen: Redirecting to legacy storedEventUrl:",
          storedEventUrl
        );
        clearStoredEventShareURL();
        // Redirect to the stored event URL
        window.location.href = storedEventUrl;
      }
    }
  }, [isLoggedIn, userData?.username, showWelcome, showWelcomeModal]);

  // Handle post-welcome flow coordination with claim coins popup
  useEffect(() => {
    // Only run this logic when welcome modal closes and user is logged in
    if (!showWelcomeModal && isLoggedIn && userData?.username) {
      const signupFlowContextStr = sessionStorage.getItem("signupFlowContext");

      if (signupFlowContextStr) {
        try {
          const signupFlowContext = JSON.parse(signupFlowContextStr);

          if (
            signupFlowContext.flowType === "notification" &&
            !signupFlowContext.suppressClaimCoinsPopup
          ) {
            console.log(
              "🔔 HomeWebScreen: Notification flow completed - claim coins popup can now appear if eligible"
            );
            // Note: The actual claim coins popup logic is handled in Header.tsx
            // This is just for logging and potential future coordination
          } else if (signupFlowContext.flowType === "gameshow") {
            console.log(
              "🎮 HomeWebScreen: GameShow flow completed - claim coins popup remains suppressed"
            );
          }

          // Check if context should be cleaned up (after redirect or welcome close without redirect)
          const hasRedirectURL = signupFlowContext.postSignupRedirectURL;
          if (!hasRedirectURL) {
            console.log(
              "🧹 HomeWebScreen: Cleaning up signup flow context (no redirect needed)"
            );
            sessionStorage.removeItem("signupFlowContext");
          }
        } catch (error) {
          console.warn(
            "⚠️ HomeWebScreen: Error parsing signup flow context in post-welcome:",
            error
          );
        }
      }
    }
  }, [showWelcomeModal, isLoggedIn, userData?.username]);

  // help decide winner popup

  // const handleVote = (vote: "player1" | "player2" | "abstain") => {
  //   console.log("User voted:", vote);
  //   setModalVisible(false);
  // };

  console.log("tooltipVisible", tooltipVisible);

  const scrollViewRef = useRef(null);

  // Show skeleton while initial data is loading
  if ((isLoading || isInitializing || !initialDataLoaded) && !userProfileData) {
    return <HomeWebScreenSkeleton />;
  }

  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <ScreenBGGradientView />
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {
          setHomeWalkThroughVisible(true);
          setTooltipVisible(true);
          setCurrentStep(0);
          setTotalSteps(12);
        }}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
        displayTutorialButton={true}
      />

      {/* // cash out details popup */}
      <View style={[styles.container, {}]}>
        <HomeHeader
          userData={userData}
          userImage={userProfileData?.profilePicture}
          isMyEvents={isMyEvents}
          setIsMyEvents={setIsMyEvents}
          setShowEventTypeModal={setShowEventTypeModal}
        />
        {/* Separater */}
        <View
          style={{
            paddingHorizontal:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "3.5%"
                : 0,
          }}
        >
          <Separator
            color={AppColors.appGrayColor_1C1C1C}
            height={1}
            marginTop={0}
            marginBottom={0}
            marginHorizontal={0}
          />
        </View>
        {/*RecommendedPopulRecommendedes */}
        {/* <Genre
          heading="Popular Genres"
          filterEventsByTag={filterEventsByTag}
          arrPopularGeners={arrPopularGeners}
        /> */}

        {/* Separater */}

        <ScrollView
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          ref={scrollViewRef}
        >
          {/* Live now slider - only show if there are live events or loading */}
          {(showLiveEventsLoader || liveEventsData.length > 0) && (
            <LiveNowSlider
              heading="Live Now"
              userData={userData}
              liveEventsData={liveEventsData}
              showLoader={showLiveEventsLoader}
            />
          )}

          <BrowsGamesComponent
            heading={"Browse Games"}
            styles={styles}
            eventsResultEmpty={gameResultEmpty}
            eventsResult={gameResult}
            showLoader={showGameResultLoader}
          />

          {/* Live Solo Streamers Section */}
          {/* Live Solo Streamers Section */}
          <LiveSoloStreamersContainer
            onStreamPress={(stream) => {
              navigateToScreen(navigation, AppScreens.SoloStreaming, {
                username: stream.username,
              });
            }}
            onUserPress={(username) => {
              navigateToScreen(navigation, AppScreens.UserProfile, {
                username: username,
                showBackArrow: true,
              });
            }}
          />

          {/* Separater */}
          <View
            style={{
              paddingHorizontal:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "3.5%"
                  : 0,
            }}
          >
            <Separator
              color={AppColors.appGrayColor_1C1C1C}
              height={2}
              marginTop={0}
              marginBottom={0}
              marginHorizontal={0}
            />
          </View>
          {/* <HomeCards
            userData={userData}
            eventID={eventID}
            heading="Popular Events"
            CardData={popularData}
            CardDataEmpty={popularEmpty}
            // setIsGetTicket={setIsGetTicket}
            accessToken={accessToken}
            showLoader={showEventPopulerLoader}
            popularIndex={popularIndex}
            setPopularIndex={setPopularIndex}
            userProfileData={userProfileData}
          /> */}
          <Cards
            userData={userData}
            eventID={eventID}
            heading="Popular Events"
            CardData={popularData}
            CardDataEmpty={popularEmpty}
            accessToken={accessToken}
            showLoader={showEventPopulerLoader}
            popularIndex={popularIndex}
            setPopularIndex={setPopularIndex}
            userProfileData={userProfileData}
            lastEvaluatedKey={popularLastEvaluatedKey}
            isFetchingMorePopularEvents={isFetchingMorePopularEvents} // highlight
            eventlimit={popularLimit}
            fetchMoreEvents={() => {
              if (popularLastEvaluatedKey) {
                getEventPopuler(
                  userData.username,
                  popularLimit,
                  popularLastEvaluatedKey
                );
              }
            }}
          />

          {/* )} */}

          {/* Separater */}
          <View
            style={{
              paddingHorizontal:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "3.5%"
                  : 0,
            }}
          >
            <Separator
              color={AppColors.appGrayColor_1C1C1C}
              height={2}
              marginTop={0}
              marginBottom={0}
              marginHorizontal={0}
            />
          </View>
          {/* Upcoming */}
          {userProfileData && (
            <Cards
              userData={userData}
              eventID={eventID}
              heading="Upcoming"
              CardData={upComingData}
              CardDataEmpty={upComingEmpty}
              // setIsGetTicket={setIsGetTicket}
              showLoader={showUpComingEventLoader}
              accessToken={accessToken}
              popularIndex={upcomingIndex}
              setPopularIndex={setUpcomingIndex}
              userProfileData={userProfileData}
              lastEvaluatedKey={upcomingLastEvaluatedKey}
              eventlimit={upcomingLimit}
              isFetchingMorePopularEvents={isFetchingMoreUpcomingEvents} // highlight
              fetchMoreEvents={() => {
                if (upcomingLastEvaluatedKey) {
                  getUpComingEvent(
                    userData.username,
                    upcomingLimit,
                    upcomingLastEvaluatedKey
                  );
                }
              }}
            />
          )}

          {/* Separater */}
          <View
            style={{
              paddingHorizontal:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "3.5%"
                  : 0,
            }}
          >
            <Separator
              color={AppColors.appGrayColor_1C1C1C}
              height={2}
              marginTop={0}
              marginBottom={0}
              marginHorizontal={0}
            />
          </View>

          {/* Recommended */}
          {userProfileData && (
            <Cards
              userData={userData}
              eventID={eventID}
              heading="Recommended"
              CardData={recommendedData}
              CardDataEmpty={recommendedEmpty}
              showLoader={showRecommendedEventLoader}
              // setIsGetTicket={setIsGetTicket}
              accessToken={accessToken}
              popularIndex={recommendedIndex}
              setPopularIndex={setRecommendedIndex}
              userProfileData={userProfileData}
              lastEvaluatedKey={recommendedLastEvaluatedKey}
              eventlimit={recommendedLimit}
              isFetchingMorePopularEvents={isFetchingMoreRecommendedEvents} // highlight
              fetchMoreEvents={() => {
                if (recommendedLastEvaluatedKey) {
                  getRecommendedEvent(
                    userData.username,
                    recommendedLimit,
                    recommendedLastEvaluatedKey
                  );
                }
              }}
            />
          )}

          {/* Separater */}
          <View
            style={{
              paddingHorizontal:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "3.5%"
                  : 0,
            }}
          >
            <Separator
              color={AppColors.appGrayColor_1C1C1C}
              height={2}
              marginTop={0}
              marginBottom={0}
              marginHorizontal={0}
            />
          </View>

          {userProfileData && (
            <Cards
              userData={userData}
              eventID={eventID}
              heading="Past Events"
              CardData={pastEventData}
              CardDataEmpty={pastEventEmpty}
              showLoader={showPastEventLoader}
              // setIsGetTicket={setIsGetTicket}
              accessToken={accessToken}
              popularIndex={pastEventIndex}
              setPopularIndex={setPastEventIndex}
              userProfileData={userProfileData}
              lastEvaluatedKey={pastLastEvaluatedKey}
              eventlimit={pastLimit}
              isFetchingMorePopularEvents={isFetchingMorePastEvents} // highlight
              fetchMoreEvents={() => {
                if (pastLastEvaluatedKey) {
                  getPastEvent(accessToken, pastLimit, pastLastEvaluatedKey);
                }
              }}
            />
          )}
        </ScrollView>

        {/* {<ShowLoader showIndicater={showLoader} />} */}
        {showNotificationDetails && (
          <NotificationDetails
            showModal={showNotificationDetails}
            setShowModal={setShowNotificationDetails}
            challengeID={challengeID}
            username={userData && userData.username}
            setIsAccepted={null}
            accessToken={accessToken}
            onAcceptPress={(isAccepted) => {
              setIsAccepted(isAccepted);
              setChallengeConformation(true);
            }}
          />
        )}

        {showChallengeConformation && (
          <ChallengeConfirmationModal
            showModal={showChallengeConformation}
            setShowModal={setChallengeConformation}
            isAccepted={isAccepted}
            accessToken={accessToken}
            challengeID={challengeID}
            onConfirmPress={(confirmed) => {
              // Context now handles the reject popup globally
              // No need to show local popup anymore
            }}
          />
        )}

        {searchFromFriendsModal && (
          <SearchFromFriendsModal
            showModal={searchFromFriendsModal}
            setShowModal={setSearchFromFriendsModal}
          />
        )}
        {showEventTypeModal && (
          <EventTypeScreen
            showModal={showEventTypeModal}
            setShowModal={setShowEventTypeModal}
          />
        )}

        {/* {isGetTicket && (
          <BuyTicketModal
            closeButTicket={() => {
              setIsGetTicket(false);
            }}
          />
        )} */}
      </View>
      {/* {obsErrorPopup && (
        <ObsConnectionErrorPopup
          obsErrorPopup={obsErrorPopup}
          setObsErrorPopup={setObsErrorPopup}
        />
      )} */}
      {isMyEvents && (
        <CreateEventModal
          showModal={isMyEvents}
          setShowModal={setIsMyEvents}
          setShowEventTypeModal={setShowEventTypeModal}
        />
      )}
      {ReferAndEarnPopup && (
        <ReferAndEarn
          showModal={ReferAndEarnPopup}
          setShowModal={setReferAndEarnPopup}
        />
      )}
      {AllSetupPopup && (
        <AllSetPopup
          showModal={AllSetupPopup}
          onClose={closePopup}
          setShowModal={setAllSetupPopup}
        />
      )}

      <WelcomePopup
        showModal={showWelcomeModal}
        setShowModal={setShowWelcomeModal}
        username={userData?.username || "User"}
        profilePicture={userProfileData?.profilePicture}
        koCoins={100}
        // Dynamic props based on flow context
        flowType={currentSignupFlowContext?.flowType || null}
        notificationAction={(() => {
          const contextAction = currentSignupFlowContext?.notificationAction;
          const storedAction = getStoredEventShareAction();
          const finalAction = contextAction || storedAction || "negotiate";

          console.log(
            "🔍 HomeWebScreen WelcomePopup notification action debug:"
          );
          console.log("  - contextAction:", contextAction);
          console.log("  - storedAction:", storedAction);
          console.log("  - finalAction:", finalAction);

          return finalAction;
        })()}
        showRedirectCountdown={
          !!(
            sessionStorage.getItem("postConfirmationRedirect") ||
            getStoredEventShareURL()
          )
        }
        showStartTutorial={
          !currentSignupFlowContext &&
          !sessionStorage.getItem("postConfirmationRedirect") &&
          !getStoredEventShareURL()
        }
        onStartTutorial={() => {
          console.log("🎯 HomeWebScreen: Starting tutorial from welcome popup");
          // Call the header's tutorial button function
          setHomeWalkThroughVisible(true);
          setTooltipVisible(true);
          setCurrentStep(0);
          setTotalSteps(12);
        }}
        onClose={() => {
          setShowWelcomeModal(false);

          // Only clean up signup flow context if there's no redirect URL
          // (if there is a redirect URL, let the redirect handler clean it up)
          const signupFlowContextStr =
            sessionStorage.getItem("signupFlowContext");
          if (signupFlowContextStr) {
            try {
              const signupFlowContext = JSON.parse(signupFlowContextStr);
              if (!signupFlowContext.postSignupRedirectURL) {
                console.log(
                  "🧹 HomeWebScreen: Cleaning up signup flow context (no redirect needed)"
                );
                sessionStorage.removeItem("signupFlowContext");
                setCurrentSignupFlowContext(null);
              } else {
                console.log(
                  "🚀 HomeWebScreen: Keeping signup flow context for redirect"
                );
              }
            } catch (error) {
              console.warn(
                "⚠️ HomeWebScreen: Error parsing context in onClose:",
                error
              );
              sessionStorage.removeItem("signupFlowContext");
              setCurrentSignupFlowContext(null);
            }
          }
        }}
        onManualRedirect={() => {
          const eventUrl =
            sessionStorage.getItem("postConfirmationRedirect") ||
            getStoredEventShareURL();
          if (eventUrl) {
            console.log("🚀 HomeWebScreen: Redirecting to:", eventUrl);

            // Clean up all signup-related sessionStorage
            sessionStorage.removeItem("postConfirmationRedirect");
            sessionStorage.removeItem("signupFlowContext");
            setCurrentSignupFlowContext(null);
            clearStoredEventShareURL();

            window.location.href = eventUrl;
          }
        }}
      />

      <ChallengeActionPopup
        showModal={challengeActionPopup}
        setShowModal={setChallengeActionPopup}
        action={challengeActionType}
        autoRedirectToHome={challengeAutoRedirect}
        redirectDelay={3000}
        onClose={() => {
          setChallengeActionPopup(false);
          setChallengeAutoRedirect(false);
        }}
        onExploreKallout={() => {
          console.log(
            "🏠 Redirecting to home page from challenge action popup"
          );
        }}
      />

      <WelcomeTooltip />
      <SignUpWalkthrough />
      <GetTicketWalkthrough />
    </View>
  );
});

export default HomeWebScreen;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    searchTextStyle: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: 459,
      height: 35,
      alignItems: "center",
      borderWidth: 0,
    },
    listBgViewStyle: {
      width: 220,
      gap: 5,
    },
    attendeesBgViewStyle: {
      backgroundColor: AppColors.appViolentColor_6D08C3,
      borderRadius: 7,
      alignSelf: "flex-start",
    },
    btnLeftStyle: {
      height: 80,
      width: 25,
      backgroundColor: AppColors.white,
      left: 0,
      top: 25,
    },
    btnRightStyle: {
      height: 80,
      width: 25,
      backgroundColor: AppColors.white,
      right: 0,
      top: 25,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      searchTextStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: 459,
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      listBgViewStyle: {
        width: 220,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      btnLeftStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        left: 0,
        top: 25,
      },
      btnRightStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        right: 0,
        top: 25,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      searchTextStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: 459,
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      listBgViewStyle: {
        width: 220,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      btnLeftStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        left: 0,
        top: 25,
      },
      btnRightStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        right: 0,
        top: 25,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        paddingHorizontal: 0,
        paddingTop: "2.5%",
      },
      searchTextStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: 459,
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      listBgViewStyle: {
        width: 220,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      btnLeftStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        left: 0,
        top: 25,
      },
      btnRightStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        right: 0,
        top: 25,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        paddingHorizontal: 0,
        paddingTop: "2.5%",
      },
      searchTextStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: 600,
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      listBgViewStyle: {
        width: 185,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      btnLeftStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        left: 0,
        top: 25,
      },
      btnRightStyle: {
        height: 80,
        width: 25,
        backgroundColor: AppColors.white,
        right: 0,
        top: 25,
      },
    },
  }
);
